export default __webpack_public_path__ + "static/media/registration.0d45c9f6.jpg";